import  { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//component
import AuthLayout from "../../../components/layout/AuthLayout";
import { useSubscribe, useLogEvent } from "../../../hooks/api/post";
import "./Sub.css";

import {
  useSubscriptionActivity,
  useFetchPlans,
} from "../../../hooks/api/fetch";
import { toast } from "react-toastify";
//image & icons
import LaunchIcon from "@mui/icons-material/Launch";
import SecurityIcon from "@mui/icons-material/Security";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { v4 as uuidv4 } from 'uuid';

export default function SubscriptionActivity() {
  const navigate = useNavigate();
  const [reloader, setReloader] = useState(0);
  const [active, setActive] = useState(null);
  const [activePayment, setActivePayment] = useState(null);
  const [planID, setPlanID] = useState("");
  const [channel, setChannel] = useState("airtime");
  const getUserID = sessionStorage.getItem("ccAuth");
  const userID = JSON.parse(getUserID);
  const token = userID.token;
  const userid = userID.id;
  const usersDigit = userID.userPassport;
  const { mutate: logEvent } = useLogEvent();
  const fetchAllSubscriptionActivity = useSubscriptionActivity({
    userid,
  });
  const generatedUuid = uuidv4();
  // Redirect URLs
  const redirectLinks = [
    {
      id: 1,
      title: "Evina Protection",
      description: "Secure Subscription Channel",
      icon: <SecurityIcon className="card-icon" />,
      url: `http://checkout.mtn-ng.dcbprotect.com/v3/lp/mtn-ng/395/9ijakids-trivia-daily-rvh96?trfsrc=9ijakids&trxId=${generatedUuid}`,
      color: "linear-gradient(135deg, #00dd6eff 0%, #13a100ff 100%)",
      btnText: "Go to Evina"
    },
    {
      id: 2,
      title: "Mfilter Service",
      description: "Secure Subscription Channel",
      icon: <FilterAltIcon className="card-icon" />,
      url: `http://mtn-nigeria-prod.mfilterit.org/sid/234102200006857?trfSrc=9ijakids&trxId=${generatedUuid}`,
      color: "linear-gradient(135deg, #c4bd00ff 0%, #ffa200ff 100%)",
      btnText: "Go to Mfilter"
    }
  ];

  // Handle card click redirect
  const handleCardClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (!userid) return;

    if (fetchAllSubscriptionActivity.isSuccess) {
      logEvent({
        userId: userid,
        action_type: "Subscription_Success",
      });
    } else if (fetchAllSubscriptionActivity.isError) {
      const status = fetchAllSubscriptionActivity?.error?.response?.status;

      if (status === 400 || status === 404) {
        logEvent({
          userId: userid,
          action_type: "Subscription_Failed",
        });
      } else if (status === 500) {
        logEvent({
          userId: userid,
          action_type: "Subscription_Pending",
        });
      } else {
        logEvent({
          userId: userid,
          action_type: "Subscription_Unknown",
        });
      }
    }
  }, [
    fetchAllSubscriptionActivity.isSuccess,
    fetchAllSubscriptionActivity.isError,
    fetchAllSubscriptionActivity?.error,
    userid,
    logEvent,
  ]);


  return (
    <AuthLayout>
      <main className="paymentCtn">
        <h1 className="paymentHeading">Subscription </h1>
        
        {/* New Clickable Cards Section */}
        <div className="redirect-cards-section">
          <h3 className="section-heading">Subscription Channels</h3>
          <p className="section-subtitle">Click on any  to subscribe</p>
          
          <div className="cards-container">
            {redirectLinks.map((card) => (
              <div 
                key={card.id}
                className="redirect-card"
                onClick={() => handleCardClick(card.url)}
                style={{ 
                  background: card.color,
                  cursor: 'pointer'
                }}
              >
                <div className="card-header">
                  {card.icon}
                  <h3 className="card-title">{card.title}</h3>
                </div>
                <div className="card-body">
                  <p className="card-description">{card.description}</p>
                </div>
                <div className="card-footer">
                  <span className="card-btn">
                    {card.btnText}
                    <LaunchIcon className="launch-icon" />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      {/* <Socket setReloader={setReloader} usersDigit={usersDigit} /> */}
    </AuthLayout>
  );
}